const faqs = [
  {
    q: '吃瓜黑料爆料网的内容来源是否可靠？',
    a: '我们所有瓜料均标注信息来源，经过内容团队交叉验证后发布。对于无法核实的信息，我们会标注"待核实"标签，确保读者了解信息的可信度等级。',
  },
  {
    q: '如何向平台投稿爆料？',
    a: '您可以通过本页面的"爆料投稿"板块发送邮件至我们的投稿邮箱。我们采用多重匿名机制处理所有投稿，发件人信息在审核环节即被脱敏处理，确保您的隐私安全。',
  },
  {
    q: '平台更新频率是怎样的？',
    a: '吃瓜黑料爆料网保持7×24小时不间断更新，内容团队全天候追踪娱乐圈最新动态。重大事件发生后的30分钟内即可看到相关爆料，日常瓜料每日至少更新3次。',
  },
  {
    q: '如何看待被爆料的明星发律师函？',
    a: '我们尊重每个人的合法权益。如果当事人认为某条信息不实，可通过官方渠道联系我们提交证明材料。经核实确属虚假信息的，我们将立即撤稿并公开更正说明。',
  },
  {
    q: 'APP和网页版有什么区别？',
    a: 'APP版本支持推送通知、离线浏览和夜间模式，让您随时随地畅快吃瓜。网页版则更适合深度阅读和专题浏览，两者数据同步，您可以根据场景自由选择。',
  },
  {
    q: '平台是否会对评论进行审核？',
    a: '我们倡导理性吃瓜、文明讨论。所有评论会经过AI+人工双重审核，对于人身攻击、造谣传谣等违规内容将直接移除。我们希望打造一个健康的吃瓜社区。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">关于吃瓜黑料爆料，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-2 font-heading flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}